
import { LitElement, css, html } from 'lit';

export class Message extends LitElement {
  message: string;
  duration: number;
  type: string;

  static styles = css`
:host {
   position: absolute;
   top: 1em;
   left: 0;
   right: 0;
   margin-left: auto;
   margin-right: auto;
   padding: 1em;
   max-width: 15em;
   border: 1px solid black;
   border-radius: 0.3em;
   z-index: 10000;
}
:host(.error) {
   background: rgba(255,128,128,0.8);
}
:host(.warning) {
   background: rgba(255,255,128,0.8);
}
:host(.message) {
   background: rgba(128,255,128,0.8);
}
.title {
  font-size: 1.1em;
  font-weight: bold;
}
`;

  constructor(msg: string, options: any = {}) {
    super();
    this.message = msg;
    this.duration = options.duration || 3;
    this.type = options.type || "message";
    this.title = this.type[0].toUpperCase() + this.type.slice(1,);
    this.classList.add(this.type);
    // @ts-ignore
    document.querySelector('body').appendChild(this);
    setTimeout(() => {
      this.remove();
    }, this.duration * 1000)
  }
  set_message(msg: string) {
    this.message = msg
    this.requestUpdate()
  }
  render() {
    return html`<div><div class="title">${this.title}</div>${this.message}</div>`;
  }
}
customElements.define('the-message', Message);


